import {
  LOADING_NOTIFICATIONS,
  LIST_NOTIFICATIONS,
  TOGGLE_NOTIFICATIONS_PANEL,
} from "../../constants/types";
import { GenericRootThunkAction } from "../../types/common";
import backend from "../../services/axios.functions";
import { INotification } from "../../types/notification/inotification.interface";

export const READ_NOTIFICATION = "UPDATE_REVIEW_STAGE";
export const READ_ALL_NOTIFICATIONS = "REORDER_REVIEW_STAGES";

export const getNotifications = (): GenericRootThunkAction => async (dispatch) => {
  dispatch({ type: LOADING_NOTIFICATIONS });
  try {
    const { data } = await backend.get(`/notifications/`);
    if (!data) {
      throw new Error("No notifications");
    }

    if (data.results) {
      dispatch({
        type: LIST_NOTIFICATIONS,
        payload: {
          notifications: data.results.sort(
            (a: any, b: any) => Date.parse(b.timestamp) - Date.parse(a.timestamp)
          ),
        },
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const markNotificationAsRead = (id: number): GenericRootThunkAction => async (dispatch) => {
  try {
    const { status, data: updatedNotification } = await backend.patch<INotification>(
      `/notifications/mark-as-read/${id}`
    );

    if (status === 200 && updatedNotification) {
      dispatch(getNotifications());
    }
  } catch (err) {
    console.log(err);
  }
};

export const markAllNotificationsAsRead = (): GenericRootThunkAction => async (dispatch) => {
  try {
    const { status } = await backend.patch(`/notifications/mark-as-read/`);

    if (status === 200) {
      dispatch({ type: READ_ALL_NOTIFICATIONS, payload: { notifications: [] } });
      dispatch(getNotifications());
    }
  } catch (err) {
    console.log(err);
  }
};

export const toggleNotifcationPanel = (): GenericRootThunkAction => (dispatch) => {
  dispatch({ type: TOGGLE_NOTIFICATIONS_PANEL });
};
